import { PROJECT_CLASSIFICATION_TYPES } from '@adsk/alloy-provider';

export const CLIENTS_PATH = '/ui/v1/clients';
export const TEMPLATE_ENTITLEMENTS_FIELDS =
  'name,accountName,defaultUrl,imageUrl,products,platform,mfaBlocked';
export const PROJECT_ENTITLEMENTS_FIELDS =
  'accountId,name,accountName,accountImageUrl,defaultUrl,classification,imageUrl,region,products,platform,mfaBlocked,jobNumber';

export const TEMPLATE_ENTITLEMENTS_CLASSIFICATION =
  PROJECT_CLASSIFICATION_TYPES.TEMPLATE;
export const PROJECT_ENTITLEMENTS_CLASSIFICATION = [
  PROJECT_CLASSIFICATION_TYPES.PRODUCTION,
  PROJECT_CLASSIFICATION_TYPES.SAMPLE,
].join(',');
export const TABS_NAMES = {
  ACCOUNTS: 'accounts',
  PROJECTS: 'projects',
  TEMPLATES: 'templates',
};

export const PROJECT_ENTITLEMENTS_LIMIT = 50;

export const SEARCH_PLACEHOLDER_KEYS = {
  [TABS_NAMES.ACCOUNTS]: 'SEARCH_ACCOUNTS',
  [TABS_NAMES.PROJECTS]: 'SEARCH_PROJECTS_WITH_NUMBER',
  [TABS_NAMES.TEMPLATES]: 'SEARCH_TEMPLATES',
};
